const Candle = ({ width = 20, height = 20, color = 'currentColor' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none">
      <path
        d="M5.41797 18.3333V12.5"
        stroke={color}
        strokeWidth="1.15385"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.41797 4.16699V1.66699"
        stroke={color}
        strokeWidth="1.15385"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.582 18.333V15.833"
        stroke={color}
        strokeWidth="1.15385"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.582 7.50033V1.66699"
        stroke={color}
        strokeWidth="1.15385"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.91797 5.83366V10.8337C7.91797 11.7503 7.5013 12.5003 6.2513 12.5003H4.58464C3.33464 12.5003 2.91797 11.7503 2.91797 10.8337V5.83366C2.91797 4.91699 3.33464 4.16699 4.58464 4.16699H6.2513C7.5013 4.16699 7.91797 4.91699 7.91797 5.83366Z"
        stroke={color}
        strokeWidth="1.15385"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.082 9.16667V14.1667C17.082 15.0833 16.6654 15.8333 15.4154 15.8333H13.7487C12.4987 15.8333 12.082 15.0833 12.082 14.1667V9.16667C12.082 8.25 12.4987 7.5 13.7487 7.5H15.4154C16.6654 7.5 17.082 8.25 17.082 9.16667Z"
        stroke={color}
        strokeWidth="1.15385"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default Candle;
